import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core';
import type { ToastButton } from '@hunting-nature/Secacam/shared/components/toast/toast-button.interface';
import { ToastType } from '@hunting-nature/Secacam/shared/components/toast/toast-type.enum';
import { ToastService } from '@hunting-nature/Secacam/shared/services/toast.service';
import { pickIcons } from '@hunting-nature/shared-ui/helper/icon-registry.const';
import { IonButton, IonIcon } from '@ionic/angular/standalone';
import { addIcons } from 'ionicons';
import { closeOutline } from 'ionicons/icons';

@Component({
  selector: 'app-toast',
  templateUrl: './toast.component.html',
  styleUrls: ['./toast.component.scss'],
  imports: [IonButton, IonIcon, NgClass],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ToastComponent {
  readonly id = input.required<number>();
  readonly title = input.required<string>();
  readonly subtitle = input<string>();
  readonly icon = input<string>();
  readonly type = input<ToastType>(ToastType.INFO);
  readonly buttons = input<Array<ToastButton>>([]);

  protected readonly ToastType = ToastType;

  // services
  private readonly toastService = inject(ToastService);

  constructor() {
    addIcons({
      closeOutline,
      ...pickIcons('toast-success', 'toast-info', 'toast-warning', 'toast-error', 'arrow-forward-outline'),
    });
  }

  handleClose(): void {
    this.toastService.dismiss(this.id());
  }

  handleClick(button: ToastButton): void {
    button.handler?.();

    this.toastService.dismiss(this.id());
  }
}
